import { ImpactModule } from 'types'
import { GEO_PAGES } from './pages'
import { GEO_PAGES_ORDER_FOR_PERMISSIONS } from './pagesOrderForPermissions'

export const GEO_MODULE: ImpactModule = {
  NAME: 'geo',
  NAME_PTBR: 'Geo',
  UPPER_NAME: 'ADMIN',
  API_NAME: 'ADMIN',
  PAGES: GEO_PAGES,
  PAGES_ORDER_FOR_PERMISSIONS: GEO_PAGES_ORDER_FOR_PERMISSIONS,
}
